import {Race, Result} from "../Results";
import {isMultilap, showCategories, showCategoryPlaces, showClub, showDiscipline} from "./RaceTableModel";
import {FC} from "react";

type Props = {
    race: Race
};


export const RaceTableBody: FC<Props> = (props: Props) => {

    function getRow(result: Result): Array<string> {
        let cols: Array<string> = []

        cols.push(result.place ? result.place.toString() : "")
        cols.push(result.sn)
        cols.push(result.name)

        if (showCategories(props.race)) {
            cols.push(result.category ? result.category : "")
        }

        if (showCategoryPlaces(props.race)) {
            cols.push(result.category_place ? result.category_place.toString() : "")
        }

        if (showClub(props.race)) {
            cols.push(result.club ? result.club : "")
        }

        const discipline = showDiscipline(props.race)
        if (discipline) {
            cols.push(result.discipline ? result.discipline : "")
        }

        const multilap = isMultilap(props.race)
        if (!multilap) {
            if (result.dnf || result.dns) {
                cols = [...cols, ...disqualificationRow(props.race.laps, result.dnf, result.dns)]
                if (!discipline) {
                    cols.push("") // diff
                }
            } else {
                cols.push(result.laps[0].time)
                if (!discipline) {
                    cols.push(result.laps[0].diff)
                }
            }
        } else {
            if (result.dnf || result.dns) {
                cols = [...cols, ...disqualificationRow(props.race.laps, result.dnf, result.dns)]
            } else {
                result.laps.map(lap => {
                    if (!lap.time) {
                        cols.push("")
                    } else if (lap.position) {
                        cols.push(lap.time + " [" + lap.position + "]")
                    } else {
                        cols.push(lap.time)
                    }
                })
            }
        }


        return cols;
    }

    function disqualificationRow(laps: number, dnf?: boolean, dns?: boolean): Array<string> {
        const cols: Array<string> = []

        for (let i = 0; i < props.race.laps; i++) {
            if (i === 0) {
                if (dns) {
                    cols.push("DNS")
                } else if (dnf) {
                    cols.push("DNF")
                } else {
                    throw Error("unknown disqualification")
                }
            } else {
                cols.push("")
            }
        }

        return cols
    }

    return (
        <tbody>

        {props.race.results.map((result, idx) => {
            return (
                <tr key={idx}>
                    {getRow(result).map((item, itemIdx) => {
                        return (
                            <td key={itemIdx}>{item}</td>
                        )
                    })}
                </tr>
            )
        })}

        </tbody>
    );
};
